import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UrlService {

  private apiUrl: string;

  constructor() {

    if (window.location.hostname === environment.vanityUrl.replace('https://', '').replace('-api', '')){
      this.apiUrl = environment.vanityUrl;
    }else{
      this.apiUrl = environment.baseURL;
    }
  }

  public getApiUrl(): string {
    return this.apiUrl;
  }
}
